module.exports = __webpack_public_path__ + "img/body-model-torso.f5c0469b.svg";